import * as React from 'react';

function IconExport(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.11 14.442H3.895a2.336 2.336 0 01-2.333-2.334V3.893A2.336 2.336 0 013.895 1.56h2.027a.733.733 0 110 1.466H3.895a.867.867 0 00-.867.867v8.215c0 .478.389.867.867.867h8.215c.478 0 .867-.39.867-.867V10.08a.733.733 0 111.466 0v2.028a2.336 2.336 0 01-2.333 2.334z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.131 8.606a.733.733 0 01-.519-1.252l5.58-5.58a.734.734 0 111.037 1.038l-5.58 5.58a.73.73 0 01-.517.214"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.71 7.96a.733.733 0 01-.734-.734v-4.2h-4.2a.733.733 0 110-1.466h4.934a.733.733 0 01.733.733v4.933a.733.733 0 01-.733.734z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoIconExport = React.memo(IconExport);
export default MemoIconExport;
